// extracted by mini-css-extract-plugin
export var container = "styles-module--container--c5ea5";
export var content = "styles-module--content--8ff63";
export var logo = "styles-module--logo--4681e";
export var section = "styles-module--section--eb3b9";